import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { FilterContext } from "../FilterContextProvider";
import Logout from "../Auth/Logout";

const ArtistsLayout = ({ children }) => {
  const chosen = "pt-4 pl-8 pr-4 text-blue-500 font-bold";
  const notChosen = "pt-4 pl-8 pr-4 hover:text-blue-500";
  const { filterData } = useContext(FilterContext);

  return (
    <div className="text-black ml-24 h-14 border-b bg-white">
      <div className="flex flex-row mb-4 text-sm text-black h-14">
        {filterData.artist_name && (
          <div className="bg-blue-500 text-white h-14 flex p-4 font-semibold">
            {filterData.artist_name}
          </div>
        )}
        <NavLink
          to="/artists/manage"
          activeClassName={chosen}
          className={notChosen}
        >
          <p>Manage Artists</p>
        </NavLink>
        <Logout></Logout>
      </div>
      <div className="bg-gray-100 pb-8">{children}</div>
    </div>
  );
};

export default ArtistsLayout;
